import React from 'react';
import { Card, CardContent } from './ui/card';
import { Shield, CheckCircle2, MessageSquare, Headphones, Lock, AlertCircle } from 'lucide-react';

export const TrustSection = () => {
  const trustPoints = [
    {
      icon: CheckCircle2,
      title: 'Customer-first policy',
      description: 'Your satisfaction and security are our top priorities. Every decision we make puts you first.'
    },
    {
      icon: Shield,
      title: 'Pay after activation',
      description: 'Zero risk for you. Only pay once you\'ve confirmed your subscription is active and working.'
    },
    {
      icon: MessageSquare,
      title: 'Clear communication',
      description: 'No hidden fees, no surprises. We explain every step and answer all your questions upfront.'
    },
    {
      icon: Headphones,
      title: 'Support from start to finish',
      description: 'We\'re with you every step of the way, from initial contact to successful activation and beyond.'
    },
    {
      icon: Lock,
      title: 'No password sharing required',
      description: 'We never ask for your passwords. Our activation process is safe, secure, and respects your privacy.'
    },
    {
      icon: AlertCircle,
      title: 'We never claim brand affiliation',
      description: 'We\'re transparent: Meta Learners is independent and not affiliated with any brand we serve.'
    }
  ];

  return (
    <section id="trust" className="py-20 px-4">
      <div className="container mx-auto">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground">
            Why <span className="gradient-text">Trust</span> Meta Learners
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Built on transparency, security, and customer satisfaction
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {trustPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <Card key={index} className="glass-card hover-glow">
                <CardContent className="p-6 space-y-4">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-lg font-bold text-foreground">{point.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {point.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Trust Statement */}
        <div className="mt-12 max-w-4xl mx-auto text-center">
          <div className="glass-card p-8 rounded-lg border-primary/30">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Shield className="w-8 h-8 text-primary" />
              <h3 className="text-2xl font-bold text-foreground">Our Promise</h3>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              We've helped thousands of customers access premium subscriptions safely and affordably. 
              Our "pay after activation" model means you risk nothing. If we can't activate your subscription, 
              you don't pay. It's that simple. We're committed to earning your trust through transparency, 
              excellent service, and results.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
